<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-alert
            class= "alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>             

          <b-form>
            <b-form-group
              label="Origen"
              label-for="bancoCuentaOrigen"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="bancoCuentaOrigen"
                :value="bancoCuentaOrigen" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <app-banco-cuenta
              label="Destino"
              :nombre="bancoCuentaDestinoNombre"
              :lista="bancosCuentasList"
              :labelCols="labelCols"
              :valido="bancoCuentaDestinoValida"
              :msjInvalido="bancoCuentaDestinoInvalidaMsj"
              @updated="bancoCuentaDestinoActualizada">
            </app-banco-cuenta>
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Actualizar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BancoCuenta from '../shared/abmSelect.vue';

export default {
  name: 'BancoMovimientoActualizacionCuenta',
  components: {
    appBancoCuenta: BancoCuenta,
  },
  props: {
    bancoMovimientoId: {
      type: Number,
      default: 0
    },
    bancoCuenta: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      noValidar: true,
      bancoCuentaDestinoValida: null,
      bancoCuentaDestinoInvalidaMsj: '',

      bancoCuentaOrigen: null,
      bancoCuentaDestino: null,

      bancosCuentas: [],
      bancosCuentasList: [],

      labelCols: 3,
      alertCountDown: 15, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',
    }
  },
  created() {
    this.bancoCuentaOrigen = this.bancoCuenta;
    
    this.getDatosAdicionales();
  },
  computed: {
    bancoCuentaDestinoNombre() {
      if (this.bancoCuentaDestino) {
        if (this.bancoCuentaDestino.nombre) {
          return this.bancoCuentaDestino.nombre.trim();
        }
      }
      return null;
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(alertMsj, alertVariant) {
      this.alertMsj = alertMsj;
      this.alertVariant = alertVariant;
      this.dismissCountDown = this.alertCountDown;
    },
    getDatosAdicionales() {
      const vm = this;

      this.showSpinner();
      this.$store.dispatch('bancoscuentas/getList')
        .then(() => {
            vm.bancosCuentas = this.$store.getters['bancoscuentas/list']
            vm.bancosCuentasList = this.$store.getters['bancoscuentas/selectList']
          })
        .catch(() => this.showAlert('Se produjo un error al recuperar la lista de cuentas bancarias.', 'danger'))
        .finally(() => this.hideSpinner());
    },
    save () {
      let save = Boolean(true);

      let bancoCuenta = null;
      if (this.bancoCuentaNombre) {
        bancoCuenta = this.getSelected(this.bancosCuentas, this.bancoCuentaNombre);
      }
      this.$store.dispatch('bancomovimiento/setBancoCuenta', bancoCuenta);

      let bancoCuentaDestinoError = true;
      if (this.bancoCuentaDestino) {
        if (this.bancoCuentaDestino.id) {
          if (this.bancoCuentaDestino.id != 0) {
            bancoCuentaDestinoError = Boolean(false);
          }
        }
      }
      if (bancoCuentaDestinoError) {
        save = false;
        this.bancoCuentaDestinoValida = false;
        this.bancoCuentaDestinoInvalidaMsj = 'Debe seleccionar la cuenta destino de la actualización.';
      }

      if (save) {
        this.showSpinner();
        let params = {
          bancoMovimientoId: this.bancoMovimientoId,
          bancoCuentaDestinoId: this.bancoCuentaDestino.id
        }
        this.$store.dispatch('bancomovimiento/actualizarCuenta', params)
          .then(() => this.$emit('closeActualizacion', true))
          .catch( error => this.showAlert(error, 'danger'))
          .finally(() => this.hideSpinner())
      }
    },
    goBack() {
      this.$emit('closeActualizacion', false);
    },
    bancoCuentaDestinoActualizada(bancoCuentaNombre) {
      this.bancoCuentaDestino = null;
      if (bancoCuentaNombre) {
        this.bancoCuentaDestino = this.getSelected(this.bancosCuentas, bancoCuentaNombre);
      }

      if (this.bancoCuentaDestino) {
        this.bancoCuentaDestinoValida = null;
        this.bancoCuentaDestinoInvalidaMsj = '';
      }
    },
  },
  watch: {
  },
}
</script>

<style>
</style>
